import axios from 'axios';

export default {
    state: {
    },
    mutations: {
      // setLoader(state, { element, val }) {
      //   state[element] = val;
      // },
    },
    actions: {
      async deleteImage({ commit }, params ) {
        let result = null;
        try {
            await axios
              .post(`/api/images/delete`, params)
              .then((response) => {
                commit
                result = response.data;
              })
        } catch (error) {
            console.error(error);
        }
        return result;
      },
      async uploadImage({ commit }, image ) {
        let result = null;
        try {
            await axios
              .post(`/api/images/load`, image)
              .then((response) => {
                commit
                result = response.data;
              })
        } catch (error) {
            console.error(error);
        }
        return result;
      },
      async addPhotoTranslation({ commit }, params ) {
        let result = null;
        try {
            await axios
              .post(`/api/events/photo`, params)
              .then((response) => {
                commit
                result = response.data;
              })
        } catch (error) {
            console.error(error);
        }
        return result;
      }
    },
    // getters: {
    //   generalLoader: (s) => s.general,
    //   timelineLoader: (s) => s.timeline,
    // },
  };
  